import SrSelect from "./SrSelect.vue";

SrSelect.install = function(Vue) {
  Vue.component(SrSelect.name, SrSelect);
};

export default SrSelect;


// WEBPACK FOOTER //
// ./packages/SrSelect/index.js